import {
  GoodReceivedStateTypes,
  GoodReceivedActionTypes,
} from "./GoodReceived.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: GoodReceivedStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchReport: resetApiCallState([]),
};

const GoodReceivedReducer = (
  state: GoodReceivedStateTypes = INITIAL_STATE,
  action: any
): GoodReceivedStateTypes => {
  switch (action.type) {
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ---

    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState([]),
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default GoodReceivedReducer;
